class Retailer {
    constructor({
      address,
      city,
      companyName,
      createdAt,
      email,
      gstNumber,
      image,
      mobile,
      name,
      password,
      pinCode,
      role,
      state,
      uid,
      userName,
      createdBy
    }) {
      this.address = address || '';
      this.city = city || '';
      this.companyName = companyName || '';
      this.createdAt = createdAt || '';
      this.email = email || '';
      this.gstNumber = gstNumber || '';
      this.image = image || '';
      this.mobile = mobile || '';
      this.name = name || '';
      this.password = password || '';
      this.pinCode = pinCode || 0;
      this.role = role || '';
      this.state = state || '';
      this.uid = uid || '';
      this.userName = userName || '';
      this.createdBy=createdBy || '';
    }
  }
  export default Retailer;